export default class KdiagramCalculationResultCalculationInputData {
  constructor(
    minDate,
    maxDate,
    trim,
    draft,
    windBft,
    windKnots
  ) {
    this.minDate = minDate;
    this.maxDate = maxDate;
    this.trim = trim;
    this.draft = draft;
    this.windBft = windBft;
    this.windKnots = windKnots;
  }
}
